/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { CalendarDto, CalendarRestService } from '@gh/builder-shared-data';
import { InitViewService } from '@gh/common-shared';
import { currentYear, orDefaultValue } from '@gh/core-util';
import { map$ } from '@gh/rx/operators';
import { Observable } from 'rxjs';
import { calendarFromDto, CalendarListItem, calendarToDto } from './scheduling-calendar-details.model';

@Injectable()
export class SchedulingCalendarDetailsBusinessService implements InitViewService {
  constructor(private calendarRest: CalendarRestService) {
  }

  initView(): any {
    return {
      calendar: this.get(currentYear()),
    };
  }

  get(year: number): Observable<CalendarListItem[]> {
    return this.calendarRest.findAllByYear(year).pipe(
      map$(orDefaultValue<CalendarDto>({ dates: [] })),
      map$(calendarFromDto),
      map$(({ dates }) => dates));
  }

  update(dates: CalendarListItem[]): Observable<void> {
    return this.calendarRest.update(calendarToDto({ dates }));
  }
}
